import { useSignal } from "@preact/signals";
import { GageLogo } from "./GageLogo.tsx";
import { isBrowser } from "../app/client-utils.ts";
import { useEffect } from "preact/hooks";
import { useAppData } from "./App.tsx";

export function PasswordSet() {
  const appData = useAppData();
  const error = useSignal('');
  const loading = useSignal(false);
  const token = useSignal<string>();
  const email = useSignal<string>();
  const success = useSignal(false);


  useEffect(() => {
    if (!isBrowser) return;
    const searchParams = new URLSearchParams(location.search);
    token.value = searchParams.get('token')!
    email.value = searchParams.get('email')!;
  }, []);

  async function onSubmit(e: SubmitEvent) {
    e.stopPropagation();
    e.preventDefault();
    const formData = new FormData(e.currentTarget as HTMLFormElement);
    const password = formData.get('password');
    try {
      loading.value = true;
      const body = JSON.stringify({
        token: token.value,
        email: email.value,
        password,
      });
      const res = await fetch('/api/set-password', { body, method: "POST" });

      if (!res.ok) throw new Error(await res.text());

      location.href = `${appData.siteURL}/welcome`;
    } catch (e) {
      error.value = e.message;
      loading.value = false;
    }
  }

  return <div class="login">
    <div className="login">
      <h2>
        <GageLogo /> Ignite.
      </h2>
      <h1>{success.value ? "Password Created, redirecting..." : "Create Password"}</h1>
      <form onSubmit={onSubmit}>
        <input name="username" type="email" placeholder="Email" disabled value={email.value} />
        <input name="password" type="password" placeholder="Password" required autoComplete="off" autofocus minLength={6} />
        <button disabled={loading.value} type="submit">Login</button>
        {error.value && <div class="error">{error.value}</div>}
      </form>
    </div>
  </div>
}